import $ from 'jquery/src/jquery'
import { Swiper } from 'swiper'
import {Navigation, Pagination, Autoplay} from "swiper/modules"
Swiper.use([Navigation, Pagination, Autoplay])

export default () => {
    const nodeSelectors = {
        container: '[js-slider="container"]',
        slider: '[js-slider="slider"]',
        slider2: '[js-slider="slider2"]',
        prev: '[js-slider="prev"]',
        next: '[js-slider="next"]',
        pagination: '[js-slider="pagination"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider2El = container.querySelector(nodeSelectors.slider2)

            let settings = {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: false,
                speed: 300,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true,
                    type: "progressbar"
                },
                breakpoints: {
                    1024: {
                        spaceBetween: 40,
                    }
                }
            }
            let customAutoplay = $(sliderEl).data('js-slider--autoplay')
            if( customAutoplay ) {
                let customAutoplayDelay = $(sliderEl).data('js-slider--autoplay-delay')
                let autoplayDelay = (customAutoplayDelay) ? customAutoplayDelay : 2000

                settings.autoplay = {
                    delay: autoplayDelay,
                    disableOnInteraction: false
                }
            }

            let slider = new Swiper(sliderEl, settings)

            if( slider2El ) {
                let slider2 = new Swiper(slider2El, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: false,
                    autoHeight: true,
                    speed: 300,
                    breakpoints: {
                        1024: {
                            spaceBetween: 40,
                        }
                    }
                })

                syncSwipers(slider, slider2)
            }
        })
    }

    function syncSwipers(primary, secondary) {
        let isSyncing = false

        const syncTo = (src, dest, idx) => {
            if (isSyncing) return
            isSyncing = true
            const targetIndex = typeof idx === 'number' ? idx : src.realIndex
            if (typeof dest.slideToLoop === 'function') {
                dest.slideToLoop(targetIndex, dest.params.speed, false)
            } else {
                dest.slideTo(targetIndex, dest.params.speed, false)
            }
            // allow the transition to start before we unlock
            setTimeout(() => { isSyncing = false }, 0)
        }

        // Whenever one changes, move the other to the same real index
        primary.on('slideChange', () => syncTo(primary, secondary))
        secondary.on('slideChange', () => syncTo(secondary, primary))

        // Clicking a slide in the secondary moves the primary
        secondary.on('click', (swiper) => {
            // real index lives on data-swiper-slide-index
            const riAttr = swiper.clickedSlide?.getAttribute('data-swiper-slide-index')
            const realIdx = riAttr != null ? Number(riAttr) : NaN
            if (!Number.isNaN(realIdx)) {
                syncTo(secondary, primary, realIdx)
            }
        })
    }

    return Object.freeze({
        init,
    })
}